import axios from '@/resources/libs/axios'

export default {
    list(data) {
        return axios.get(`/gei/auxiliaries/companies/list/all`, { params: data })
    },
    search(data) {
        return axios.get(`/gei/auxiliaries/companies/list`,{ params: data })
    },
    find(data) {
        return axios.get(`/gei/auxiliaries/companies/find/${data.id}`,{ params: data })
    },
    create(data) {
        return axios.post(`/gei/auxiliaries/companies/create`,  data)
    },
    update(data) {
        return axios.post(`/gei/auxiliaries/companies/update`,  data)
    },
    delete(id) {
        return axios.delete(`/gei/auxiliaries/companies/delete/${id}`)
    },
}